(function() {
    // 注册组件
    SR.modules.extend('ask', ask);

    function ask() {
        var isImmersive = SR.state.isImmersive;
        var $body = SR.dom.$body;
        var $wrapper = SR.dom.$wrapper;
        var $scrollWrap = SR.dom.$scrollWrap;
        var $historyWrapper = SR.dom.$historyWrapper;
        var loadingTag = SR.data.loadingTag;
        var scrollAnimateDuration = SR.data.scrollAnimateDuration;

        // 暴露提问接口
        /**
         * @name ask
         * @param {string}    question                      问题内容
         * @param {object}    options                       选项
         * @param {string}    options.answerContainerId     渲染答案容器 id，默认为 $wrapper
         * @param {boolen}    options.scrollToAsk           是否自动滑动至提问位置
         * @param {boolen}    options.scrollToAnswer        是否自动滑动至答案位置
         * @param {boolen}    options.isLoadHistory         是否是历史问题
         * @param {boolen}    options.isTheater             是否是剧场模式
         * @param {boolen}    options.inputType             问题输入方式
         * @param {string}    options.askAgain              重新提问，
         *                                                  reload: 重载答案，
         *                                                  refresh: 刷新答案
         * @param {function}  options.callbackHandle        获取答案后回调函数
         */
        window.ask = function(question, options) {
            if (!question) {
                SR.state.isDebug && console.log('ask event: question is not defined');
                return;
            }
            question = question.replace(/<[^>]+>/g, '');
            options = options || {};
            options.scrollToAnswer = options.scrollToAnswer === undefined ? true : options.scrollToAnswer;
            var $answerContainer = options.answerContainerId ? $('#' + options.answerContainerId) : $wrapper;
            var opt;

            if ($body.hasClass(loadingTag)) {
                return;
            }
            // 敏感词过滤
            if (SR.state.wordsFilter && !options.hasCheckedWords) {
                SR.modules.checkWords(question, options);
                return;
            }
            if (question === SR.command.testAllScenes) {
                SR.debug.test.testAllScenes();
                return;
            }
            if (question === SR.command.clearStorage) {
                SR.debug.test.clearStorage();
                return;
            }
            if (question === SR.command.debug) {
                SR.debug.test.debug();
                return;
            }
            if (question === SR.command.cls) {
                window.cls();
                return;
            }

            if (question && question.trim().length) {
                // 触发事件
                SR.App.trigger('beforeAsk', [options, question]);
                if (options.continue === false) {
                    return;
                }
                var askId = 'askId-' + Date.now();
                // 即时显示问题对话框
                if (options.askAgain !== 'reload') {
                    $answerContainer.append(
                        SR.modules.answer.packageData({
                            type: 'stock',
                            scene: 'ask',
                            data: question,
                            id: askId
                        })
                    );
                }
                // 滑动页面到当前提问位置
                if (options.scrollToAsk !== false) {
                    $scrollWrap.stop(false, false).animate(
                        {
                            scrollTop: $wrapper.height() + $historyWrapper.height() - 30
                        },
                        scrollAnimateDuration
                    );
                }
                // 删除原有答案
                if (options.askAgain === 'reload') {
                    var $dom = $('#' + options.askId);
                    $dom.next('.robot').remove();
                }
                // 请求答案
                opt = {
                    question: question,
                    askId: askId,
                    $answerContainer: $answerContainer,
                    askOptions: options
                }
                if (SR.state.askMode === 'staff') {
                    SR.App.trigger('askFire:staff', [opt]);
                    console.log('askFire:staff');
                    return;
                }
                // 广播 askFire 事件，用于特定场景处理
                SR.App.trigger('askFire', [opt]);
                SR.modules.answer.getData(opt);
                // SR.state.isDebug && console.log(opt);
            }
        };

        // 批量提问接口
        /**
         * @name askAll
         * @param {array}     questionsArray                问题
         * @param {object}    options                       选项
         * @param {string}    options.answerContainerId     渲染答案容器 id，默认为 $wrapper
         * @param {boolen}    options.scrollToAsk           是否自动滑动至提问位置
         * @param {boolen}    options.scrollToAnswer        是否自动滑动至答案位置
         * @param {boolen}    options.isLoadHistory         是否是历史问题
         * @param {function}  options.callbackHandle        获取答案后回调函数
         * @param {function}  options.finalCallbackHandle   完成全部请求后回调函数
         */
        window.askAll = function(questionsArray, options) {
            options = options || {};
            if (questionsArray.length > 0) {
                if (options.isLoadHistory) {
                    askQueue(questionsArray.pop());
                } else {
                    askQueue(questionsArray.shift());
                }
            }

            function askQueue(question) {
                var q = typeof question === 'object' ? question.q : question;
                var iOptions = Object.assign({
                    scrollToAsk: false,
                    scrollToAnswer: false,
                    showAnimate: false,
                }, options);
                iOptions.callbackHandle = function(askInfo) {
                    options.callbackHandle && options.callbackHandle(askInfo, question);
                    var nextQuestion = options.isLoadHistory ? questionsArray.pop() : questionsArray.shift();
                    if (nextQuestion) {
                        askQueue(nextQuestion);
                    } else {
                        options.finalCallbackHandle && options.finalCallbackHandle();
                    }
                }
                window.ask(q, iOptions);
            }
        };
    }
})();
